import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "guide-cta" }
const _hoisted_2 = { class: "guide-cta__modal" }
const _hoisted_3 = { class: "guide-cta__body" }
const _hoisted_4 = { class: "guide-cta__loading" }
const _hoisted_5 = ["src"]

import { ref } from "vue";

const DIALOG_WIDTH = 960;

/* ---------------------------------------------------------------------------
 * Props
 * --------------------------------------------------------------------------- */

export default /*@__PURE__*/_defineComponent({
  __name: 'GuideCTA',
  props: {
    guideUrl: { default: "https://app.guideflow.com/embed/qkqdxyxu1p" }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

/* ---------------------------------------------------------------------------
 * State
 * --------------------------------------------------------------------------- */
const isOpen = ref(false);
const isLoading = ref(true);

/* ---------------------------------------------------------------------------
 * Actions
 * --------------------------------------------------------------------------- */
function openGuide() {
  isLoading.value = true;
  isOpen.value = true;
  emit("click");
}

function closeGuide() {
  isOpen.value = false;
  isLoading.value = true; // reset for next open
}

function onIframeLoad() {
  isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      class: "guide-cta__trigger",
      variant: "flat",
      "aria-label": "What's new",
      onClick: openGuide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, {
          color: "#424242",
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("mdi-lightbulb-on-outline", -1)
          ]))]),
          _: 1
        }),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-weight-large" }, "What's new?", -1))
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: isOpen.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
      persistent: "",
      transition: "dialog-bottom-transition",
      width: DIALOG_WIDTH,
      "content-class": "guide-cta__dialog-content",
      class: "guide-cta__dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              icon: "",
              size: "x-small",
              color: "white",
              class: "guide-cta__close",
              "aria-label": "Close guide",
              onClick: closeGuide
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "small" }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_progress_linear, {
                indeterminate: "",
                color: "mpBlue",
                class: "guide-cta__progress"
              })
            ], 512), [
              [_vShow, isLoading.value]
            ]),
            (isOpen.value)
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 0,
                  src: __props.guideUrl,
                  class: "guide-cta__iframe",
                  title: "Workflow guide",
                  onLoad: onIframeLoad
                }, null, 40, _hoisted_5))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})